import { useLayoutEffect } from "react"

import { useDispatch } from "react-redux"

import { getFaq } from "../../redux/referrals.thunks"
import Benefits from "./Benefits"
import Faq from "./Faq"
import HowItWorks from "./HowItWorks"

import "./styles.less"

const InfoBlock = () => {
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    dispatch(getFaq())
  }, [])

  return (
    <div>
      <HowItWorks />
      <Benefits />
      <Faq />
    </div>
  )
}

export default InfoBlock
